// components/CustomerDataActions/CustomerDataActions.jsx
import { Box } from "@material-ui/core";
import BulkImportCustomersLink from "components/BulkImportCustomers/BulkImportCustomersLink";
import ExportCustomersButton from "components/ExportCustomers/ExportCustomersButton";

export default function CustomerDataActions({ dealerId }) {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            style={{ gap: 18, marginTop: -5 }}
        >
            <BulkImportCustomersLink dealerId={dealerId} />
            <ExportCustomersButton dealerId={dealerId} />
        </Box>
    );
}
